/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { environment } from '../helpers';
import { Client } from './lar.logistica.api';
import KeycloakService from '../../core_web/keycloak/session';

export default class ApiFactory {
  private static axiosInstance: AxiosInstance;

  private static handleRequest = async (config: AxiosRequestConfig) => {
    const token = KeycloakService.getToken();
    if (token) {
      config.headers!.Authorization = `Bearer ${token}`;
    }

    return config;
  };

  private static handleRequestError = (error: any) => {
    return Promise.reject(error);
  };

  private static handleResponse = (response: AxiosResponse) => {
    return response;
  };

  private static handleResponseError = async (error: any) => {
    if (error.response?.status === 401) {
      KeycloakService.handleAuthenticationFailure();
    }

    return Promise.reject(error);
  };

  public static GetClient(): Client {
    if (!ApiFactory.axiosInstance) {
      ApiFactory.axiosInstance = axios.create();
      ApiFactory.axiosInstance.defaults.timeout = 60000;
      ApiFactory.axiosInstance.interceptors.request.use(
        this.handleRequest,
        this.handleRequestError
      );
      ApiFactory.axiosInstance.interceptors.response.use(
        this.handleResponse,
        this.handleResponseError
      );
    }
    const client = new Client(environment.GetApiUrl(), ApiFactory.axiosInstance);
    return client;
  }
}
